import { Link, Outlet } from 'react-router-dom';
import { Button } from '@mui/material';
import { useAuth } from '../../contexts';
import { BtnFuture } from '../components';
import Sun from '../../images/sun.png';
import { MobileMenu } from './mobile-menu';
import { Footer } from './footer';
import './header-footer.scss';

export const Header = () => {
    const { user, signUp } = useAuth();
    const handleSignUp = async () => {
        try {
            await signUp();
            window.location.reload();
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className='App'>
            <div className='header'>
                <BtnFuture url={`/`} text='Головна' />
                <div className='logo'>
                    <Link to={'/'}>
                        <img src={Sun} alt='weather' className='logo-image' />
                    </Link>
                    <h2>Погода в Україні та як вдягнути дитину</h2>
                </div>
                <div className='header-login'>
                    {user ?
                        <>
                            <h3 className='header-login_user-name'>{user.email}</h3>
                            <BtnFuture url={`/children`} text='Список дітей' />
                            <Button variant='contained'
                                sx={{
                                    marginLeft: '10px',
                                    backgroundColor: '#6565f5',
                                    boxShadow: 'none',
                                    fontSize: '18px',
                                    lineHeight: '1.4',
                                    textTransform: 'none',
                                    '&:hover': { backgroundColor: '#4d4de9' }
                                }}
                                onClick={handleSignUp}>
                                Вийти
                            </Button>
                        </>
                        :
                        <>
                            <BtnFuture url={`/login`} text='Зареєструватися' />
                            <BtnFuture url={`/sign`} text='Увійти' />
                        </>
                    }
                </div>
            </div>
            <MobileMenu handleSignUp={handleSignUp} />
            <Footer />
            <Outlet />
        </div >
    )
}